import { render } from "./SwitchToggle.vue?vue&type=template&id=aae95902&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"

import "./SwitchToggle.vue?vue&type=style&index=0&id=aae95902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae95902"]])

export default __exports__